<template>
    <translates
        :item="this.item"
        :item_id="parseInt(item.id)"
        item_type="pwa_article">
    </translates>
</template>
<script>
import translates from "../../../../../translates/translates.vue";

export default {
    name: "pwa_article_translates",
    components: {translates},
    props : {
        item : {
            type : Object
        }
    },
}
</script>



<style scoped>

</style>
